/**
 * START A CREW (desktop) — `design/GT Crew.dc.html`,
 * `data-screen-label="Start a crew"`.
 *
 * A 560px card rather than the phone's fluid column, with the mirror's larger
 * rail and label type. The card is shared; see `components/StartCrewCard.tsx`.
 */

import { StartCrewCard } from '../../components/StartCrewCard.tsx';

export default function StartCrew(): JSX.Element {
  return (
    <StartCrewCard
      m={{
        pad: '44px 24px',
        width: '560px',
        cardPad: '26px 26px 24px',
        gap: '18px',
        labelFs: '9px',
        railNumFs: '9px',
        railLabelFs: '9px',
      }}
    />
  );
}
